import moment from 'moment-timezone';

function dateOnlyFormat(input: string | Date | null | undefined, format?: string): string | null {
  if (input == null) {
    return null;
  }

  const date = moment(input, 'YYYY-MM-DD');
  return date.format(format);
}

export default dateOnlyFormat;
